/** @format */

import React, { useEffect, useState } from 'react';
import Sidebar from '../common/SideBar';
import LogoutModal from '../ui/LogoutModal';
import { useAuthStore } from '../../context/useAuthStore';
import { Outlet } from 'react-router-dom';

interface DashboardLayoutProps {
	children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = () => {
	const { user, logout } = useAuthStore();
	const [showModal, setShowModal] = useState(false);
	const [userName, setUserName] = useState<string>('');

	useEffect(() => {
		if (user) {
			setUserName(user.fullName || 'Unknown User');
		} else {
			setUserName('User');
		}
	}, [user]);

	const handleModalClose = () => {
		setShowModal(false);
	};

	const handleLogoutClick = async () => {
		await logout();
		setShowModal(false);
	};

	return (
		<main className='dashboardLayoutContainer no-scrollbar'>
			<Sidebar onLogout={() => setShowModal(true)} />
			<section className='dashboardLayoutSection no-scrollbar'>
				<Outlet />
			</section>
			<LogoutModal
				userName={userName}
				showModal={showModal}
				onClose={handleModalClose}
				onLogout={handleLogoutClick}
			/>
		</main>
	);
};

export default DashboardLayout;
